module.exports = __webpack_public_path__ + "media/images/market-value-be9e449c70dcd5ac315fb296d0aaba7c.svg";